import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import '@fs/react-scripts/polyfills'
import * as Sentry from '@sentry/browser'
import { allLocales, setAppLocales } from '@fs/zion-locale'
import { Switch, Router } from '@fs/zion-router'
import { appPath, sentryDSN, mergeSentryConfig } from '@fs/zion-config'
import { FrontierBaseProviders } from '@fs/zion-root'

import { NoticeLoading } from '@fs/zion-icon'
import RebuggerClient from '@fs/zion-rebugger/AppClient'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './locales'

// Enable local feature flag development using the file "dev.flags.js"
// If that file exports anything truthy it will initialize feature flags in localhost mode
// and use the flags defined in that file, instead of flags defined in split.
const mockFlags = process.env.NODE_ENV === 'development' ? import('./dev.flags').then((m) => m.default) : undefined
const mockActivities =
  process.env.NODE_ENV === 'development' ? import('./dev.activities').then((m) => m.default) : undefined

// initialize Sentry for the app
if (sentryDSN) {
  // pass Sentry overrides to mergeSentryConfig
  Sentry.init(
    mergeSentryConfig({
      strictFiltering: true,
      dsn: sentryDSN,
      ignoreErrors: [
        /Attempt to delete range from database/,
        /Cannot read properties of undefined \(reading 'pathname'\)/,
        /Database deleted by request of the user/,
        /Failed to fetch/,
        /Internal error./,
        /Invalid destructuring assignment target/,
        /Non-Error promise rejection captured with value: undefined/,
        /null is not an object \(evaluating 'this.rule.id'\)/,
        /Request failed with status code 401/,
        /SQLError/,
        /The arity of each "output" value must be equal/,
        /The transaction was aborted/,
        /undefined is not an object \(evaluating 'e.pathname'\)/,
        /undefined is not an object \(evaluating 'n.length'\)/,
        /useSpring/,
        /w is not a function. \(In 'w\(\)', 'w' is undefined\)/,
      ],
    })
  )
}

// Here we pass the mounted app path from the server to the client.
const base = appPath ? new URL(appPath).pathname : ''

// Add any app logic here as flags, languages and translations are now configured and available
const FrontierWrapper = () => {
  setAppLocales(allLocales)

  return (
    <Router basename={base}>
      <Suspense fallback={<div />}>
        <Switch>
          <App />
        </Switch>
      </Suspense>
    </Router>
  )
}

// Do not make changes to FrontierRoot, all changes should be made to FrontierWrapper
const FrontierRoot = () => (
  <React.StrictMode>
    <Suspense fallback={<NoticeLoading />}>
      <FrontierBaseProviders mockFlags={mockFlags} mockActivities={mockActivities}>
        <FrontierWrapper />
      </FrontierBaseProviders>
    </Suspense>
    {/* hide in production build */}
    {process.env.NODE_ENV === 'development' && <RebuggerClient />}
  </React.StrictMode>
)

ReactDOM.render(<FrontierRoot />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
